import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { MyBookings, MyBookingsItem } from '@/api/MyBookings/myBookings.interfaces';
import { ReducerStatus, RootState } from '../types';
import { MyBookingsState } from './types';
import { convertToDate } from '@shared/helpers/datetime/datetime';

const initialState: MyBookingsState = {
    status: ReducerStatus.INITIAL,
    data: null,
    authenticated: null,
};

const state: MyBookingsState = {
    ...initialState,
};

const getters: GetterTree<MyBookingsState, RootState> = {
    getStatus(state): ReducerStatus {
        return state.status;
    },

    getItems(state): MyBookingsItem[] {
        return state.data?.items ?? [];
    },

    getIsAuthenticated(state): boolean {
        return state?.authenticated ?? false;
    },

    getIsVerified(state): boolean {
        return state.data?.verified ?? false;
    },
};

const actions: ActionTree<MyBookingsState, RootState> = {
    setLoading({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADING,
            data: null,
        });
    },

    setSuccess({ state, commit }, payload: MyBookings) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADED,
            data: mapData(payload),
            authenticated: true,
        });
    },

    setUnauthorized({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.LOADED,
            data: null,
            authenticated: false,
        });
    },

    setError({ state, commit }) {
        commit('setState', {
            ...state,
            status: ReducerStatus.ERROR,
            data: null,
        });
    },

    clearState({ commit }) {
        commit('setState', initialState);
    },
};

const mutations: MutationTree<MyBookingsState> = {
    setState(state, payload) {
        Object.assign(state, payload);
    },
};

export const myBookings: Module<MyBookingsState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

function mapData(data: MyBookings) {
    return {
        ...data,
        items: data.items.sort((a, b) => {
            const dateA = a?.created ? convertToDate(a.created).getTime() : 0;
            const dateB = b?.created ? convertToDate(b.created).getTime() : 0;
            return dateB - dateA;
        }),
    };
}
